import { serviceAssets } from '../../../constants/assets'

type CreateServiceCardProps = {
  onCreate: () => void
}

export const CreateServiceCard = ({ onCreate }: CreateServiceCardProps) => (
  <button
    type="button"
    onClick={onCreate}
    className="flex h-[324px] w-[299px] shrink-0 flex-col items-center justify-center gap-[12px] rounded-[14px] border-[1.6px] border-dashed border-dash-svc-create-border bg-transparent shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.1)] transition-colors hover:bg-white/40 motion-reduce:transition-none"
  >
    <span className="flex size-[48px] items-center justify-center rounded-full bg-dash-svc-create-btn px-[12px]">
      <img
        alt=""
        aria-hidden
        className="block size-[24px] max-w-none"
        src={serviceAssets.createPlus}
      />
    </span>

    <span className="font-host text-[18px] font-medium leading-[28px] text-dash-svc-create-ink">
      Create New Service
    </span>

    <span className="max-w-[200px] text-center font-host text-[14px] font-normal leading-[20px] text-dash-svc-create-muted">
      Add a new offering to your menu
    </span>
  </button>
)
